import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/MisFillRateReport';

const MisFillRateReport = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">REPORTS - Fill Rate Report </h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

    
  </Container>
);

MisFillRateReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MisFillRateReport);
